import { render } from "./TheDisclaimer.vue?vue&type=template&id=23a5fda6"
import script from "./TheDisclaimer.vue?vue&type=script&lang=js"
export * from "./TheDisclaimer.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__